<template>
  <v-dialog
    v-model="getModalHistoricoStatusOS"
    persistent
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title> Histórico de Status </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Status</th>
                <th>Data/Hora</th>
                <th>Funcionário</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in getOrdemServico.historico_status" :key="s.id">
                <td>{{ s.status }}</td>
                <td>{{ $helper.formatDateTime(s.created_at) }}</td>
                <td>{{ s.funcionario.nome_abreviado }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          @click="setModalHistoricoStatusOS(false)"
          outlined
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["getOrdemServico", "getModalHistoricoStatusOS"]),
  },
  methods: {
    ...mapActions(["setModalHistoricoStatusOS"]),
  },
};
</script>